import generateKey from '../utils/generateKey';
if (process.env.BROWSER) {
    window.XHSCallbacks = window.XHSCallbacks || {};
    window.XHSInvokeCallback = (data, key) => {
        if (window.XHSCallbacks[key]) {
            window.XHSCallbacks[key](data);
        }
    };
}
/**
 * Web平台的Bridge方法回调注册
 * @param method Bridge方法名字
 * @param callback Bridge方法的回调
 */
export function addCallback(method, callback) {
    const key = `${method}_${generateKey()}`;
    // native回调
    window.XHSCallbacks[key] = callback;
    return `window.XHSCallbacks.${key}`;
}
